<template>
    <!--Nowe-->
    <div class="col-lg-12 form-group filter-size pt-2 pb-2 border" :id="'survey-stats-'+question_id"
         :data-element-stats="jsonAnswersStats">
        <div class="row my-1">
            <div class="ml-3">
                <input type="checkbox" v-model="isResultVisible"></input>
            </div>
            <div class="ml-2">
                <label class="h6 font-weight-bold" v-if="!is_name_surname_question">{{ questionNumber + '. ' + questionContent }}</label>
                <label class="h6 font-weight-bold" v-else>{{ questionContent }}</label>
            </div>
        </div>

        <div class="col-12" v-if="isResultVisible">
            <div class="row mt-3 mb-4 pt-2 border-top border-bottom justify-content-center">
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="isAnswersCountVisible"></input>
                    <label class="mr-3">{{ $lang('Liczba odpowiedzi') }}</label>
                </div>
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="isCorrectPercentageVisible" v-if="dataCorrectPercentage!==false"></input>
                    <label class="mr-3" v-if="dataCorrectPercentage!==false">{{ $lang('Procent poprawnych odpowiedzi') }}</label>
                </div>
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="areGroupedAnswersVisible"></input>
                    <label class="mr-3">{{ $lang('Rozkład procentowy odpowiedzi') }}</label>
                </div>
            </div>

            <div class="row my-2" v-if="isAnswersCountVisible">
                <div class="col-lg-3 col-md-4 col-sm-5 col-6 font-weight-bold">
                    <label>{{ $lang('Liczba odpowiedzi:') }}</label>
                </div>
                <div class="col-lg-9 col-md-8 col-sm-7 col-6">
                    <label>{{ answersCount }}</label>
                </div>
            </div>

            <div v-if="dataCorrectPercentage!==false">
                <div class="row my-2" v-if="isCorrectPercentageVisible">
                    <div class="col-lg-3 col-md-4 col-sm-5 col-6 font-weight-bold">
                        <label>{{ $lang('Procent poprawnych odpowiedzi:') }}</label>
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-7 col-6">
                        <label>{{ dataCorrectPercentage+'%' }}</label>
                    </div>
                </div>
            </div>

            <div v-if="areGroupedAnswersVisible">
                <div class="row mt-2">
                    <div class="col-12 font-weight-bold">
                        <label>{{ $lang('Rozkład procentowy odpowiedzi:') }}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ul v-for="answer in groupedAnswers">
                            <li v-if="answer.content">
                                <label
                                    class="m-0">{{ Math.round(answer.count * 100 / answersCount) + '% : ' + answer.content }}</label>
                            </li>
                            <li v-else>
                                <label class="m-0">{{ Math.round(answer.count * 100 / answersCount) + '% : ' }}</label>
                                <label class="font-italic m-0">{{ $lang('Nie podano') }}</label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "survey-date-stats",
    props: {
        question_id: Number,
        grouped_answers: Array,
        answers_count: Number,
        correct_percentage: [Number, Boolean],
        question_content: String,
        question_number: Number,
        is_name_surname_question: {type: Boolean, default: false},
    },
    data() {
        return {
            groupedAnswers: this.grouped_answers,
            answersCount: this.answers_count,
            dataCorrectPercentage: this.correct_percentage,
            questionContent: this.question_content,
            questionNumber: this.question_number,
            isResultVisible: true,
            isAnswersCountVisible: true,
            isCorrectPercentageVisible: true,
            areGroupedAnswersVisible: true,
            answersStats: [],
            jsonAnswersStats: null,
        }
    },
    created() {
        this.answersStats.push({'selected': this.isResultVisible});
        this.answersStats.push({'answersCount': this.isAnswersCountVisible});
        if (this.dataCorrectPercentage!==false) {
            this.answersStats.push({'correctPercentage' : this.isCorrectPercentageVisible})
        }
        this.answersStats.push({'groupedAnswers': this.areGroupedAnswersVisible});
        this.jsonAnswersStats = JSON.stringify(this.answersStats);
    },
    watch: {
        answersStats: {
            handler: function (val, oldVal) {
                this.jsonAnswersStats = JSON.stringify(this.answersStats);
            },
            deep: true
        },
        isResultVisible: function (val) {
            if (!this.isResultVisible) {
                this.answersStats = [];
                this.answersStats.push({'selected': this.isResultVisible});
            } else {
                this.answersStats = [];
                this.answersStats.push({'selected': this.isResultVisible});
                this.answersStats.push({'answersCount': this.isAnswersCountVisible});
                if (this.dataCorrectPercentage!==false) {
                    this.answersStats.push({'correctPercentage' : this.isCorrectPercentageVisible})
                }
                this.answersStats.push({'groupedAnswers': this.areGroupedAnswersVisible});
                this.jsonAnswersStats = JSON.stringify(this.answersStats);
            }
        },
        isAnswersCountVisible: function (val) {
            this.answersStats.forEach(function (item) {
                if (item.hasOwnProperty("answersCount")) {
                    item.answersCount = val;
                }
            });
        },
        isCorrectPercentageVisible: function (val) {
            if (this.dataCorrectPercentage!==false) {
                this.answersStats.forEach(function (item){
                    if(item.hasOwnProperty("correctPercentage")) {
                        item.correctPercentage = val;
                    }
                })
            }
        },
        areGroupedAnswersVisible: function (val) {
            this.answersStats.forEach(function (item) {
                if (item.hasOwnProperty("groupedAnswers")) {
                    item.groupedAnswers = val;
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
